import { forwardRef, FunctionComponent, useCallback } from "react";
import { Theme, makeStyles, TextField, StandardTextFieldProps } from "@material-ui/core";

const TEXTFIELD_HEIGHT = 50;

const useStyles = makeStyles((theme: Theme) => ({
  textField: {
    margin: theme.spacing(2),
    backgroundColor: theme.palette.grey[200],
    fontSize: 24,
    height: TEXTFIELD_HEIGHT,
    maxWidth: TEXTFIELD_HEIGHT / 1.3,
    textAlign: "center",
    borderRadius: theme.spacing(1),
    display: "flex",
  },
  input: {
    textAlign: "center",
    flex: 1,
    height: TEXTFIELD_HEIGHT,
    margin: 0,
    padding: 0,
  },
}));

export interface ILoginFormCodeTextFieldProps extends StandardTextFieldProps {}

export const LoginFormCodeTextField: FunctionComponent<ILoginFormCodeTextFieldProps> = forwardRef((props, ref) => {
  const { onChange, value, ...rest } = props;

  const classes = useStyles();

  const customOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value.length < 2 ? event.target.value : event.target.value[1];
      if (newValue.length < 2 && onChange) {
        event.target.value = newValue;
        onChange(event);
      } else {
        event.preventDefault();
      }
    },
    [onChange],
  );

  return (
    <TextField
      inputRef={ref}
      InputProps={{ disableUnderline: true }}
      className={classes.textField}
      inputProps={{ className: classes.input }}
      onChange={customOnChange}
      value={value}
      type="tel"
      {...rest}
    />
  );
});
